import { render, staticRenderFns } from "./detailDynamic.vue?vue&type=template&id=79497300&scoped=true&"
import script from "./detailDynamic.vue?vue&type=script&lang=js&"
export * from "./detailDynamic.vue?vue&type=script&lang=js&"
import style0 from "./detailDynamic.vue?vue&type=style&index=0&id=79497300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79497300",
  null
  
)

export default component.exports